/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ZoomRegularAi from './zoom-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ZoomRegularAi {...validProps} />;
}
SvgComponent.iconName = 'zoomRegularAi';

export const ZoomRegularAiIcon = svgIconWrapper(SvgComponent);
